import dynamic from "next/dynamic";

export const Layout = dynamic(() => import("./component"));
